import { mutatorAction } from 'satcheljs';
import getProfileStore from '../store/profileStore';

export default mutatorAction('REMOVE_ACCOUNT_SUCCEEDED', (accountSourceId: string) => {
    const store = getProfileStore();
    store.accountSources = store.accountSources.filter(
        accountSource => accountSource.id !== accountSourceId
    );
});
